import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from "axios";
import getBaseUrl from "../utils/apiUrl";
import token from "../utils/tokenAuthorization";



const initialState = {
    listMonitorKelas: [],
    currentPage: 1,
    keterangan: null,
    urutan: {
        column: 'nama',
        order: 'asc'
    },
    search: '',


    errors: {
        nama: '',
        email: '',
        password: '',
        kelas: '',
    },

    isInitialGet: false,
    statusResApi: '',
    messageResApi: '',
    isDisplayMessage: false,

    isLoading: true,
};

export const getMonitorKelas = createAsyncThunk("monitorkelas/getMonitorKelas", async ({ search }, { rejectWithValue }) => {
    try {

        const response = await axios.get(
            getBaseUrl + '/api/monitorkelas',
            {
                headers: {
                    Authorization: `Bearer ${token()}`,
                },
                params: {
                    search
                },
                timeout: 20000
            }
        )
        return response.data
    } catch (error) {
        if (axios.isCancel(error)) {
            throw new Error('Request canceled');
        }

        if (error.code === 'ECONNABORTED') {
            return rejectWithValue('Request timeout');
        } else if (error.response.data.admin === false) {
            return rejectWithValue('Permission denied');
        }

        return rejectWithValue(error.message)
    }
})


const monitorKelasSlice = createSlice({
    name: 'jadwalguru',
    initialState,
    reducers: {

        updateStateMonitorKelas: (state, action) => {

            const { name, value } = action.payload
            state[name] = value
        },


        resetTable: (state) => {
            state.listMonitorKelas = []
            state.isLoading = true
        },

    },
    extraReducers: (builder) => {
        builder
            .addCase(getMonitorKelas.pending, (state) => {
                console.log("halo mo")
                state.isLoading = true;
            })
            .addCase(getMonitorKelas.fulfilled, (state, action) => {
                console.log(action.payload);
                state.isLoading = false;
                state.listMonitorKelas = action.payload;
                state.isInitialGet = true
            })
            .addCase(getMonitorKelas.rejected, (state, action) => {
                state.isLoading = false;
                state.statusResApi = action.error.message
                state.messageResApi = action.payload
                state.isDisplayMessage = true
            })





    }
});

export const {
    updateFieldValue, updateFieldError, resetForm, updateClassSiswa,setFormLoading, resetField, resetTable,
    setImgUpload, updateStateMonitorKelas,deleteKelas, updateStateSiswa, resetListSiswa, showFormError
} = monitorKelasSlice.actions;
export default monitorKelasSlice.reducer;